<template>
  <!-- 特集ページのサムネイル画像を表示する共通コンポーネント。
       ヘッダーメニュー (HeaderExperiencesDropdown 等) とキーワード検索モーダルで共通利用する。
       - 親要素は `position: relative` を持つこと。本要素は親の枠を absolute inset-0 で埋める
       - 画像なし: bg-beige1 のプレースホルダ
       - 画像あり: 下部黒グラデ (常時) + 黒フィルタ (md+ 常時) で文字の視認性と操作性を担保
       - 親要素に `group` クラスがあれば、ホバー時に画像を緩やかにスケールアップする -->
  <div class="absolute inset-0 overflow-hidden bg-beige1">
    <!-- NOTE: will-change-transform は付けない。img が合成レイヤーに昇格すると、特定バージョンの
         iOS Safari で z-index 未指定の兄弟要素（タイトル・グラデ overlay）より上に描画される
         WebKit バグを踏み、テキストが画像の裏に隠れる（JCAT-5320） -->
    <OptimizedImage
      v-if="src"
      loading="lazy"
      :alt="alt"
      :class="['absolute inset-0 size-full object-cover transition-transform duration-500 group-hover:scale-[1.02]']"
      :image-url="src"
      :optimized-image-options="{ width: 560 }"
    />
    <template v-if="src">
      <!-- 下部から立ち上がる黒グラデ -->
      <div aria-hidden="true" class="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
      <!-- 黒フィルタ (PC のみ): 視認性・操作性担保 -->
      <div aria-hidden="true" class="pointer-events-none absolute inset-0 hidden bg-black/20 md:block" />
    </template>
  </div>
</template>

<script setup lang="ts">
import { OptimizedImage } from '@/wabunka-src/common/components';

// 呼び出し元は CMS の生 URL（getBackgroundImageUrl 由来）を渡し、最適化は OptimizedImage が行う。
defineProps<{
  src?: string;
  alt?: string;
}>();
</script>
